import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createMemo } from '../../GenericWizardBlockThunk';
import { reportDWH } from '../../GenericWizardBlockSlice';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config';


const SuccessPage = (props) => {

    useEffect(() => {
        props.createMemo();
        props.reportDWH({ actionType: 'SupportStepGuide', status: 'Completed', messageText: 'Success Page Displayed' })
      }, []);

    function onclickBtn(){
        buildUrlAndOpenSameWindow(props.successPage.buttonLink);
    }


    return (
        <div className="success-page">
            <div className='content'>
                <div className='img-success'>
                    <Image src={ Config.epiBaseUrl + props.successPage.icon} alt='success-icon' />
                </div>
                {props.successPage.title && <div className='title' dangerouslySetInnerHTML={{ __html: props.successPage.title }}></div>}
                {props.successPage.subTitle && <div className='sub-title' dangerouslySetInnerHTML={{ __html: props.successPage.subTitle }}></div>}
            </div>
            <div className='button-wrapper'>
                   <BtnSubmit text={props.successPage.buttonText} onclick={() => onclickBtn()} formid={'success-page'}/>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        successPage: state.genericWizardBlock.epiBlockData.successPage,
    };
};

const mapDispatchToProps = { createMemo, reportDWH };

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
